import styled from "styled-components";


const NoInfo = props => {
    const { icon, text, color, spin, button, buttonOnClick } = props;

    return (
        <Container>
            {spin ? <Spinner>{icon}</Spinner> : icon}
            <p style={{color: color || "#ccc", marginTop: '20px'}}>{text}</p>
            {button && <span className="btn-outline-light" onClick={buttonOnClick}>{button}</span>}
        </Container>
    )
}

export default NoInfo;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  text-align: center;
`;

const Spinner = styled.div`
    -webkit-transform-origin: 50% 50%;
    transform-origin:50% 50%;
    -ms-transform-origin:50% 50%; /* IE 9 */
    -webkit-animation: spin 2s infinite linear;
    -moz-animation: spin 2s infinite linear;
    -o-animation: spin 2s infinite linear;
    animation: spin 2s infinite linear;

  @-moz-keyframes spin {
    from {
      -moz-transform: rotate(0deg);
    }
    to {
      -moz-transform: rotate(360deg);
    }
  }

  @-webkit-keyframes spin {
    from {
      -webkit-transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

